import { render, staticRenderFns } from "./DashBigNumbers.vue?vue&type=template&id=4b492095&scoped=true"
import script from "./DashBigNumbers.vue?vue&type=script&lang=js"
export * from "./DashBigNumbers.vue?vue&type=script&lang=js"
import style0 from "./DashBigNumbers.vue?vue&type=style&index=0&id=4b492095&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b492095",
  null
  
)

export default component.exports